import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgZaiLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 194 76",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M48.748 10.748v15.2L60.8 38 43.374 55.426V5.374L38 0 0 38l27.252 27.252v-15.2L15.2 38l17.426-17.426v50.052L38 76l38-38-27.252-27.252Z",
			fill: "url(#zai-gradient)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M162.446 14.735v2.62c-3.244-2.2-7.138-3.355-11.357-3.355C137.356 14 127 24.532 127 38.5c0 13.967 10.356 24.5 24.089 24.5 4.275 0 8.167-1.125 11.357-3.269v2.534H174v-47.53h-11.554ZM151.18 51.753c-7.16 0-12.356-5.574-12.356-13.253 0-7.68 5.196-13.253 12.356-13.253 4.585 0 8.879 2.174 11.266 5.689v15.127c-2.387 3.515-6.681 5.69-11.266 5.69Z",
			fill: "#242936"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m131 62-7.251-10.708H103.69L128.942 14H83.515l7.25 10.708h17.487L83 62h48ZM182 0l12 12V0h-12ZM178 14l3.647 5.158V62H194V14h-16Z",
			fill: "#242936"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "zai-gradient",
			x1: 38,
			y1: 76,
			x2: 38,
			y2: 0,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6738BD" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#EE3932"
			})]
		}) })
	]
});
export { SvgZaiLogo as ReactComponent };
